var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { UploadOutlined } from '@ant-design/icons';
import { Button, Card, DatePicker, Form, Input, message, Modal, Select, Space, Spin, Table, Upload } from 'antd';
import { useEffect, useState } from 'react';
import certificateService from '../../../services/certificateService';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { UserActivity } from '../../../config/BVConstants';
import commonService from '../../../services/CommonService';
const UploadNewCertificate = (props) => {
    var _a, _b, _c, _d;
    const [form] = Form.useForm();
    const customFormat = (value) => `${value.format('DD-MM-YYYY')}`;
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const navigate = useNavigate();
    const applicationData = useSelector((state) => state.applicationData);
    const [loading, setLoading] = useState(false);
    const boolScreenAccessCheck = ((_d = (_c = (_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.getClientUserScreenAccess) === null || _a === void 0 ? void 0 : _a.lstClientUserCompanies) === null || _b === void 0 ? void 0 : _b.find((obj) => { var _a, _b; return obj.intId === ((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.intCompanyID); })) === null || _c === void 0 ? void 0 : _c.lstObjLuScreens) === null || _d === void 0 ? void 0 : _d.find((obj) => obj.intId === 3)) != undefined;
    useEffect(() => {
        var _a;
        if (!((_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.subscriptionDetails) === null || _a === void 0 ? void 0 : _a.boolCertificateUploadCertificateFeature) || !boolScreenAccessCheck) {
            navigate('/no-access');
            return;
        }
        form.setFieldsValue({
            certList: [...Array(5)].map((_, index) => ({
                boolDisableRow: index === 0 ? false : true,
                validate: index === 0 ? true : false,
                disableTech: true,
                reqServiceTypeWireless: false
            }))
        });
    }, [form]);
    const optSerType = applicationData.serviceTypeList.map((obj) => ({
        label: obj.strLongDesc,
        value: obj.intId
    }));
    const optProdType = applicationData.productTypeList.map((obj) => ({
        label: obj.strLongDesc,
        value: obj.intId
    }));
    const optCountry = applicationData.countryTerritoryList.map((obj) => ({
        label: obj.strLongDesc,
        value: obj.intId
    }));
    const optTechType = applicationData.technologyTypeList.map((obj) => ({
        label: obj.strLongDesc,
        value: obj.intId
    }));
    const normFile = (e) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e === null || e === void 0 ? void 0 : e.fileList;
    };
    const customUploadRequest = (rowIndex_1, _a) => __awaiter(void 0, [rowIndex_1, _a], void 0, function* (rowIndex, { file, onSuccess, onError }) {
        try {
            // Simulate a successful response
            const formData = new FormData();
            formData.append('file', file);
            formData.append('strPathType', 'DIRECT_CERT_UPLOAD');
            certificateService.saveDocument(formData).then((res) => {
                const certList = form.getFieldValue('certList') || [];
                certList[rowIndex]['validate'] = true;
                certList[rowIndex]['strDocRefId'] = res;
                form.setFieldsValue({ certList });
            }).catch((error) => {
                var _a;
                setLoading(false);
                message.error((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data);
            });
            ;
            setTimeout(() => {
                if (onSuccess) {
                    onSuccess({ status: 'success' });
                }
            }, 10);
        }
        catch (error) {
            if (onError) {
                onError(error);
            }
            message.error('Failed to upload file.');
        }
    });
    const handleUploadRemove = (rowIndex, file) => {
        const certList = form.getFieldValue('certList') || [];
        certificateService.deleteDocument(certList[rowIndex]['strDocRefId']).then((res) => {
            form.resetFields([['certList', rowIndex, 'strDocRefId']]);
        });
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(true);
            }, 10);
        });
    };
    const onDownload = (file) => {
        // Example: Trigger a download for a file located at file.url
        if (file.url) {
            const a = document.createElement('a');
            a.href = file.url;
            a.download = file.name;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
        else if (file.originFileObj) {
            // If the file is local (not yet uploaded), read it as a Blob
            const reader = new FileReader();
            reader.readAsArrayBuffer(file.originFileObj);
            reader.onload = () => {
                const blob = new Blob([reader.result]);
                const a = document.createElement('a');
                a.href = URL.createObjectURL(blob);
                a.download = file.name;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(a.href);
            };
        }
    };
    const handleFileChange = (fileList) => {
        const { status } = fileList.file;
        if (status !== 'uploading') {
            fileList.status = 'done';
            message.success(`${fileList.file.name} ${fileList.file.status} file uploaded successfully.`);
        }
    };
    const onSelectChange = (selectedRowKeys) => {
        setSelectedRowKeys(selectedRowKeys);
    };
    const handleDelete = (remove) => {
        remove(selectedRowKeys.map((key) => parseInt(String(key))));
        setSelectedRowKeys([]); // Clear selection after deletion
        form.validateFields();
    };
    const handleSelectChange = (rowIndex, fieldName, value) => {
        const certList = form.getFieldValue('certList') || [];
        if (fieldName === 'objLuServiceCode') {
            if (value === 100) {
                certList[rowIndex]['disableTech'] = false;
                certList[rowIndex]['reqServiceTypeWireless'] = true;
                form.setFieldsValue({ certList });
            }
            else {
                certList[rowIndex]['disableTech'] = true;
                certList[rowIndex]['reqServiceTypeWireless'] = false;
                form.setFieldsValue({ certList });
                form.resetFields([['certList', rowIndex, 'objLuTechnologyType', 'intId']]);
            }
        }
        else if (fieldName === 'objLuCountry' || fieldName === 'objLuProductType') {
            certList[rowIndex]['validate'] = true;
            form.setFieldsValue({ certList });
        }
    };
    const onChangeDate = (rowIndex, fieldName, date) => {
        const certList = form.getFieldValue('certList') || [];
        certList[rowIndex]['validate'] = true;
        if (fieldName === 'dtCertIssueDate') {
            if (date) {
                certList[rowIndex]['certIssueDate'] = date.add(1, 'day').format('DD-MM-YYYY');
                if (certList[rowIndex]['strCertId'] && certList[rowIndex + 1]) {
                    certList[rowIndex + 1]['boolDisableRow'] = false;
                }
                form.setFieldsValue({ certList });
            }
            else {
                form.resetFields([['certList', rowIndex, 'certIssueDate']]);
            }
        }
        if (fieldName === 'dtCertExpirationDate') {
            if (date) {
                certList[rowIndex]['certExpiredDate'] = date.subtract(1, 'day').format('DD-MM-YYYY');
                form.setFieldsValue({ certList });
            }
            else {
                form.resetFields([['certList', rowIndex, 'certExpiredDate']]);
            }
        }
    };
    const onFieldChange = (rowIndex, fieldName, value) => {
        const certList = form.getFieldValue('certList') || [];
        if (fieldName === 'strCertId') {
            if (certList[rowIndex]['strCertId'] &&
                certList[rowIndex]['dtCertIssueDate'] &&
                certList[rowIndex + 1]) {
                certList[rowIndex + 1]['boolDisableRow'] = false;
                form.setFieldsValue({ certList });
            }
        }
        else if (fieldName === 'strProductName' ||
            fieldName === 'strProductModel' ||
            fieldName === 'objBrandName') {
            certList[rowIndex]['validate'] = true;
            form.setFieldsValue({ certList });
        }
    };
    const inputStyle = { width: '160px' };
    const columns = [
        {
            title: 'Product Name',
            width: '20%',
            fixed: 'left',
            key: 'key',
            dataIndex: 'strProductName',
            render: (text, record, index) => (_jsx(_Fragment, { children: _jsx(Form.Item, { name: [record.key, 'strProductName'], rules: [
                        {
                            required: form.getFieldValue(['certList', record.key, 'validate']),
                            message: ''
                        }
                    ], children: _jsx(Input, { style: inputStyle, placeholder: "Product Name", disabled: form.getFieldValue(['certList', record.key, 'boolDisableRow']), onChange: (e) => onFieldChange(index, 'strProductName', e.target.value) }) }) }))
        },
        {
            title: 'Product Model',
            width: '20%',
            fixed: 'left',
            dataIndex: 'strProductModel',
            render: (text, record, index) => (_jsx(Form.Item, { name: [record.key, 'strProductModel'], rules: [
                    {
                        required: form.getFieldValue(['certList', record.key, 'validate']),
                        message: ''
                    }
                ], children: _jsx(Input, { style: inputStyle, placeholder: "Product Model", disabled: form.getFieldValue(['certList', record.key, 'boolDisableRow']), onChange: (e) => onFieldChange(record.key, 'strProductModel', e.target.value) }) }))
        },
        {
            title: 'Brand/ OEM',
            width: '20%',
            fixed: 'left',
            dataIndex: ['objBrandName', 'strLongDesc'],
            render: (text, record, index) => (_jsx(Form.Item, { name: [record.key, 'objBrandName', 'strLongDesc'], rules: [
                    {
                        required: form.getFieldValue(['certList', record.key, 'validate']),
                        message: ''
                    }
                ], children: _jsx(Input, { style: inputStyle, placeholder: "Brand/OEM", disabled: form.getFieldValue(['certList', record.key, 'boolDisableRow']), onChange: (e) => onFieldChange(record.key, 'objBrandName', e.target.value) }) }))
        },
        {
            title: 'Country/ Territory',
            width: '20%',
            dataIndex: ['objLuCountry', 'intId'],
            render: (text, record, index) => (_jsx(Form.Item, { name: [record.key, 'objLuCountry', 'intId'], rules: [
                    {
                        required: form.getFieldValue(['certList', record.key, 'validate']),
                        message: ''
                    }
                ], children: _jsx(Select, { showSearch: true, filterOption: (input, option) => { var _a; return ((_a = option === null || option === void 0 ? void 0 : option.label) !== null && _a !== void 0 ? _a : '').toLowerCase().includes(input.toLowerCase()); }, style: inputStyle, placeholder: "Country/Territory", options: optCountry, disabled: form.getFieldValue(['certList', record.key, 'boolDisableRow']), onChange: (value) => handleSelectChange(record.key, 'objLuCountry', value) }) }))
        },
        {
            title: 'Service Type',
            width: '20%',
            dataIndex: ['objLuServiceCode', 'intId'],
            render: (text, record, index) => (_jsx(Form.Item, { name: [record.key, 'objLuServiceCode', 'intId'], rules: [
                    {
                        required: form.getFieldValue(['certList', record.key, 'validate']),
                        message: ''
                    }
                ], children: _jsx(Select, { showSearch: true, filterOption: (input, option) => { var _a; return ((_a = option === null || option === void 0 ? void 0 : option.label) !== null && _a !== void 0 ? _a : '').toLowerCase().includes(input.toLowerCase()); }, onChange: (value) => handleSelectChange(record.key, 'objLuServiceCode', value), style: inputStyle, placeholder: "Service Type", options: optSerType, disabled: form.getFieldValue(['certList', record.key, 'boolDisableRow']) }) }))
        },
        {
            title: 'Product Sub Segment',
            width: '20%',
            dataIndex: ['objLuProductType', 'intId'],
            render: (text, record, index) => (_jsx(Form.Item, { name: [record.key, 'objLuProductType', 'intId'], rules: [
                    {
                        required: form.getFieldValue(['certList', record.key, 'validate']),
                        message: ''
                    }
                ], children: _jsx(Select, { showSearch: true, filterOption: (input, option) => { var _a; return ((_a = option === null || option === void 0 ? void 0 : option.label) !== null && _a !== void 0 ? _a : '').toLowerCase().includes(input.toLowerCase()); }, style: inputStyle, placeholder: "Product Sub Segment", options: optProdType, disabled: form.getFieldValue(['certList', record.key, 'boolDisableRow']), onChange: (value) => handleSelectChange(record.key, 'objLuProductType', value) }) }))
        },
        {
            title: 'Technology',
            width: '20%',
            dataIndex: ['objLuTechnologyType', 'intId'],
            render: (text, record, index) => (_jsx(Form.Item, { name: [record.key, 'objLuTechnologyType', 'intId'], rules: [
                    {
                        required: form.getFieldValue(['certList', record.key, 'reqServiceTypeWireless']),
                        message: ''
                    }
                ], children: _jsx(Select, { showSearch: true, filterOption: (input, option) => { var _a; return ((_a = option === null || option === void 0 ? void 0 : option.label) !== null && _a !== void 0 ? _a : '').toLowerCase().includes(input.toLowerCase()); }, style: inputStyle, placeholder: "Technology Type", options: optTechType, disabled: form.getFieldValue(['certList', record.key, 'boolDisableRow']) ||
                        form.getFieldValue(['certList', record.key, 'disableTech']) }) }))
        },
        {
            title: 'Certificate ID',
            width: '20%',
            dataIndex: 'strCertId',
            render: (text, record, index) => (_jsx(Form.Item, { name: [record.key, 'strCertId'], rules: [
                    {
                        required: form.getFieldValue(['certList', record.key, 'validate']),
                        message: ''
                    }
                ], children: _jsx(Input, { style: inputStyle, placeholder: "Certificate Id", disabled: form.getFieldValue(['certList', record.key, 'boolDisableRow']), onChange: (e) => onFieldChange(record.key, 'strCertId', e.target.value) }) }))
        },
        {
            title: 'Certificate Issue Date',
            width: '20%',
            dataIndex: 'dtCertIssueDate',
            render: (text, record, index) => (_jsx(Form.Item, { name: [record.key, 'dtCertIssueDate'], rules: [
                    {
                        required: form.getFieldValue(['certList', record.key, 'validate']),
                        message: ''
                    }
                ], children: _jsx(DatePicker, { style: inputStyle, format: customFormat, onChange: (date, dateString) => onChangeDate(record.key, 'dtCertIssueDate', date), multiple: false, maxDate: dayjs(form.getFieldValue(['certList', record.key, 'certExpiredDate']), 'DD-MM-YYYY'), disabled: form.getFieldValue(['certList', record.key, 'boolDisableRow']) }) }))
        },
        {
            title: 'Certificate Expiration Date',
            width: '20%',
            dataIndex: 'dtCertExpirationDate',
            render: (text, record, index) => (_jsx(Form.Item, { name: [record.key, 'dtCertExpirationDate'], children: _jsx(DatePicker, { style: inputStyle, format: customFormat, multiple: false, onChange: (date, dateString) => onChangeDate(record.key, 'dtCertExpirationDate', date), minDate: dayjs(form.getFieldValue(['certList', record.key, 'certIssueDate']), 'DD-MM-YYYY'), disabled: form.getFieldValue(['certList', record.key, 'boolDisableRow']) }) }))
        },
        {
            title: 'Certificate Document',
            width: '20%',
            dataIndex: 'certUpload',
            render: (text, record, index) => (_jsx(Form.Item, { name: [record.key, 'certUpload'], valuePropName: "fileList", getValueFromEvent: normFile, rules: [
                    {
                        required: form.getFieldValue(['certList', record.key, 'validate']),
                        // required:false,
                        message: 'Required'
                    }
                ], children: _jsx(Upload, { name: "files", maxCount: 1, onChange: handleFileChange, customRequest: (options) => customUploadRequest(record.key, options), showUploadList: { showDownloadIcon: true }, onDownload: onDownload, onRemove: (file) => handleUploadRemove(record.key, file), children: _jsx(Button, { type: "primary", disabled: form.getFieldValue(['certList', record.key, 'boolDisableRow']), icon: _jsx(UploadOutlined, {}), children: "Upload" }) }) }))
        }
    ];
    function formatDateValue(date) {
        // console.log(date)
        if (date === null || date.getFullYear() === 1970) {
            return null;
        }
        const formattedDate = `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1)
            .toString()
            .padStart(2, '0')}/${date.getFullYear()} ${date
            .getHours()
            .toString()
            .padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date
            .getSeconds()
            .toString()
            .padStart(2, '0')}`;
        return formattedDate;
    }
    const handleRedirectCertificate = (objDirectCertificate) => {
        var _a;
        const strProjectId = (_a = objDirectCertificate === null || objDirectCertificate === void 0 ? void 0 : objDirectCertificate.lstNewCertificateUploadClient[0]) === null || _a === void 0 ? void 0 : _a.strRefId;
        navigate('/certificates', { state: { strProjectId: strProjectId } });
    };
    const CertUploadSuccess = (objDirectCertificate) => {
        Modal.success({
            title: 'Certificates uploaded successfully.',
            centered: true,
            content: _jsxs(_Fragment, { children: ["Reference ID: ", objDirectCertificate === null || objDirectCertificate === void 0 ? void 0 : objDirectCertificate.strRefId] }),
            onOk() {
                handleRedirectCertificate(objDirectCertificate);
            }
        });
    };
    const onFinish = (values) => {
        var _a, _b;
        setLoading(true);
        const objCreateNewCert = {
            objCreatedBy: { objUser: { intId: (_b = (_a = applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.intCompanyID } }
        };
        objCreateNewCert['intSingleCertificate'] = 0;
        values.certList = values.certList.filter((value) => value.validate);
        values.certList.forEach((value, index) => {
            delete values.certList[index]['certUpload'];
            if (value.dtCertIssueDate) {
                const dtCertIssue = formatDateValue(new Date(value.dtCertIssueDate));
                values.certList[index]['dtCertIssueDate'] = dtCertIssue;
            }
            if (value.dtCertExpirationDate) {
                const dtExpire = formatDateValue(new Date(value.dtCertExpirationDate));
                values.certList[index]['dtCertExpirationDate'] = dtExpire;
            }
            values.certList[index]['strAction'] = 'NEW';
            values.certList[index]['objLuRequestType'] = { intId: 1 };
        });
        objCreateNewCert['lstNewCertificateUploadClient'] = values.certList;
        certificateService.saveClientCertUpload(objCreateNewCert).then((res) => {
            var _a, _b;
            setLoading(false);
            CertUploadSuccess(res);
            commonService
                .logUserActivity((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId, UserActivity.CP__Cert_Bulk_Upload_Visited);
        });
    };
    return (_jsx(Card, { style: { borderRadius: '0px' }, title: 'Upload New Certificates', children: _jsx(Spin, { size: "default", spinning: loading, tip: "Loading", children: _jsxs(Form, { form: form, layout: "vertical", name: "Certificate-form-Bulk-upload", onFinish: onFinish, children: [_jsx(Form.List, { name: "certList", children: (fields, { add, remove }) => (_jsxs(_Fragment, { children: [_jsxs(Space, { size: [20, 0], wrap: true, children: [_jsx(Button, { style: { width: '75px' }, type: "primary", onClick: () => add({ validate: false, disableTech: true, reqServiceTypeWireless: false }), children: "Add" }), _jsx(Button, { style: { width: '75px' }, type: "primary", onClick: () => handleDelete(remove), children: "Delete" })] }), _jsx("br", {}), _jsx("br", {}), _jsx(Table, { size: "small", columns: columns, rowSelection: {
                                        type: 'checkbox',
                                        selectedRowKeys,
                                        onChange: onSelectChange,
                                        getCheckboxProps: (record) => ({
                                            disabled: record.key === 0
                                        })
                                    }, dataSource: fields.map((field, index) => (Object.assign(Object.assign({}, field), { key: index }))), pagination: { position: ['bottomLeft'], defaultPageSize: 5 }, scroll: { x: 2000 } }), _jsx(Form.Item, {})] })) }), _jsx(Form.Item, { children: _jsx("div", { style: { textAlign: 'center', marginTop: '15px' }, children: _jsx(Button, { type: "primary", htmlType: "submit", children: 'Submit' }) }) })] }) }) }));
};
export default UploadNewCertificate;
